import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface EditCompletedProjectsData {
  projectDescription: string;
  projectLocation: string;
  projectName: string;
  projectImage: string;
}

export interface initialStateType {
  ar: EditCompletedProjectsData;
  en: EditCompletedProjectsData;
}

const initialState: initialStateType = {
  ar: {
    projectDescription: '',
    projectLocation: '',
    projectName: '',
    projectImage: '',
  },
  en: {
    projectDescription: '',
    projectLocation: '',
    projectName: '',
    projectImage: '',
  },
};

const editCompletedProjectsSlice = createSlice({
  name: 'editCompletedProjects',
  initialState,
  reducers: {
    setEditCompletedProjectsData: (
      state,
      action: PayloadAction<{
        projectData: initialStateType;
      }>,
    ) => {
      const { projectData } = action.payload;

      // state = projectData; // Update project data for the specific language
      state.ar = projectData.ar;
      state.en = projectData.en;
    },
    clearEditCompletedProjectsData: (state) => {
      state.ar = initialState.ar;
      state.en = initialState.en;
    },
    updateEditCompletedProjectFieldValue: (
      state,
      action: PayloadAction<{
        language: 'ar' | 'en';
        field: string;
        value: any;
        isSameValue: boolean;
      }>,
    ) => {
      const { language, field, value, isSameValue } = action.payload;
      state[language][field] = value;
      if (isSameValue) {
        state['ar'][field] = value;
        state['en'][field] = value;
      }
    },
  },
});

export const {
  setEditCompletedProjectsData,
  updateEditCompletedProjectFieldValue,
  clearEditCompletedProjectsData,
} = editCompletedProjectsSlice.actions;

export const editCompletedProjectsReducer = editCompletedProjectsSlice.reducer;

export interface EditCompanyProjectsState extends initialStateType {}
